import { take as sagaTake, fork, put as sagaPut, } from 'redux-saga/effects';
export function put(action) {
    return sagaPut(action);
}
export function take(actionType) {
    return sagaTake(actionType);
}
export function* initialize() {
}
export function* rootSaga() {
    yield [
        fork(initialize),
    ];
}
//# sourceMappingURL=sagas.js.map


// WEBPACK FOOTER //
// ./src/sagas.js